"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var LENGTH_TO_ANGLE = {
    1: 0.5,
    2: 0.7,
    3: 0.8,
    4: 0.9,
    5: 0.1,
    6: 0.1,
    7: 0.12,
    8: 0.12,
    9: 0.12,
    10: 0.12,
    11: 0.13,
    12: 0.13,
    13: 0.14,
    14: 0.15,
    15: 0.16,
    16: 0.17,
    17: 0.17,
    18: 0.18,
    19: 0.18,
    20: 0.19,
    21: 0.2,
    22: 0.21,
    23: 0.21,
};
var TYPES = {
    big: {
        width: 480,
        height: 150,
        radius: 650,
        translateX: 230,
        translateY: 705,
        font: 'bold 32px sans-serif',
        extraLongFont: 'bold 28px sans-serif',
    },
    small: {
        width: 375,
        height: 120,
        radius: 480,
        translateX: 180,
        translateY: 520,
        font: 'bold 23px sans-serif',
        extraLongFont: 'bold 20px sans-serif',
    },
};
var getPixelRatio = function () {
    var ctx = document.createElement('canvas').getContext('2d'), dpr = window.devicePixelRatio || 1, bsr = ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1;
    return dpr / bsr;
};
var CurveText = function (_a) {
    var text = _a.text, _b = _a.type, type = _b === void 0 ? 'small' : _b;
    (0, react_1.useEffect)(function () {
        var ratio = getPixelRatio();
        var cnv = document.getElementById(text);
        var config = TYPES[type];
        var color = getComputedStyle(document.documentElement)
            .getPropertyValue('--wheel-curve-text')
            .trim();
        cnv.width = config.width * ratio;
        cnv.height = config.height * ratio;
        cnv.style.width = config.width + 'px';
        cnv.style.height = config.height + 'px';
        var ctx = cnv.getContext('2d');
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        ctx.font = text.length >= 19 ? config.extraLongFont : config.font;
        ctx.fillStyle = color || '#fff';
        ctx.textAlign = 'center';
        var angle = Math.PI * (LENGTH_TO_ANGLE[text.length] || 0.17); // in radians
        var radius = config.radius;
        ctx.translate(config.translateX, config.translateY);
        ctx.rotate((-1 * angle) / 2);
        for (var i = 0; i < text.length; i++) {
            ctx.rotate(angle / text.length);
            ctx.save();
            ctx.translate(0, -1 * radius);
            ctx.fillText(text[i], 0, 0);
            ctx.restore();
        }
        /*eslint-disable-next-line*/
    }, []);
    return react_1.default.createElement("canvas", { id: text });
};
exports.default = CurveText;
